/**
 * For maintainability we should separate controllers into their own modules
 */
angular
  .module('acme.view.application.coupons.list.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.view.application.coupons.list.createCoupon.controllers',
    'acme.view.application.coupons.list.removeCoupon.controllers',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.helpers',
    'acme.common.service.lunchLitely',
  ])

  .controller('CouponsListController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$uibModal',
    'ApiService',
    'PermissionsService',
    'GridStateFactory',
    'GridDefinitionFactory',
    'HelpersService',
    'LunchLitelyService',
    function ($scope, $state, $filter, $timeout, $uibModal, ApiService, PermissionsService, GridStateFactory, GridDefinitionFactory, HelpersService, LunchLitelyService) {
      var REDEMPTION_FLAG = 'coupons_redemption_limit';
      var REDEMPTION_FLAG_TIMEOUT_MS = 3000;
      var REDEMPTION_FIELDS = ['orderRedemptionLimit', 'redemptionStatus', 'orderRedemptionCount', 'ticketRedemptionLimit'];

      $scope.couponsList = {
        searchQuery: '',
        isRedemptionEnabled: false,
        isGridReady: false,
        redemptionStatus: '',
        redemptionStatuses: [
          { label: 'All', value: '' },
          { label: 'Active', value: 'active' },
          { label: 'Redeemed', value: 'redeemed' },
        ],

        isLoaded: false,

        listRequestId: 0,

        model: [],

        categories: [],

        accounts: [],

        filtered: [],

        gridState: new GridStateFactory(),
        gridDefinition: new GridDefinitionFactory(),
        gridName: $state.current.name + '.grid0',
        viewId: '',

        optionsOverride: {
          data: 'couponsList.model',
          rowClasses:
            "{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-canceled-row': (row.entity.showCanceledState && row.entity.isCanceled) }",
          columnDefs: [
            {
              field: 'id',
              displayName: 'ID',
              visible: false,
            },
            {
              field: 'name',
              displayName: 'name',
            },
            {
              field: 'code',
              displayName: 'code',
            },
            {
              field: 'description',
              displayName: 'description',
            },
            {
              field: 'orderRedemptionLimit',
              displayName: 'order redemption limit',
              cellFilter: 'redemptionLimit',
              enableSorting: false,
            },
            {
              field: 'redemptionStatus',
              displayName: 'redemption status',
              cellFilter: 'redemptionStatus',
              enableSorting: false,
            },
            {
              field: 'orderRedemptionCount',
              displayName: 'order redemption count',
              cellFilter: 'redemptionCount',
              visible: false,
              enableSorting: false,
            },
            {
              field: 'ticketRedemptionLimit',
              displayName: 'ticket redemption limit',
              cellFilter: 'redemptionLimit',
              visible: false,
              enableSorting: false,
            },
          ],
          appScopeProvider: {
            onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
              $scope.couponsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
            },
            onDataGridSortChange: function (grid, columns, page) {
              $scope.couponsList.onDataGridSortChange(grid, columns, page);
            },
            onDblClick: function (row) {
              $scope.couponsList.onDblClick(row);
            },
            remove: function (row, col) {
              $scope.couponsList.removeCoupon(row);
            }
          },
        },

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Coupons',
            buttonRight: {
              label: '+ Create Coupon',
              permissions: 'COUPONS_CREATE',
              action: function () {
                $scope.couponsList.createCoupon();
              },
            },
          });

          if (PermissionsService.check('COUPONS_DELETE')) {
            $scope.couponsList.optionsOverride.columnDefs.push({
              field: 'remove',
              displayName: 'Remove',
              onCellNavClick: function (row, col) {
                $scope.couponsList.removeCoupon(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>',
            });
          }

          if (PermissionsService.check('COUPONS_UPDATE')) {
            $scope.couponsList.optionsOverride.columnDefs.unshift({
              field: 'edit',
              displayName: 'Edit',
              width: 50,
              onCellNavClick: function (row, col) {
                $scope.couponsList.onDblClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            });
          }

          this.viewId = $state.current.name;

          this.getCouponCategories();
          this.getAccounts();

          $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
          $scope.$on('$destroy', function () {
            $scope.couponsList.isDestroyed = true;
          });

          this.redemptionFlag = this.getRedemptionFlag();
          this.redemptionFlag.then(this.initGrid);
        },

        initGrid: function (isRedemptionEnabled) {
          var self = $scope.couponsList;
          $scope.$applyAsync(function () {
            if (self.isDestroyed) {
              return;
            }
            self.isRedemptionEnabled = isRedemptionEnabled;
            if (!isRedemptionEnabled) {
              self.optionsOverride.columnDefs = self.optionsOverride.columnDefs.filter(function (col) {
                return REDEMPTION_FIELDS.indexOf(col.field) === -1;
              });
            }
            self.gridDefinition.init(self.gridName, self.optionsOverride, self.viewId, $state.current.data.enablePreferences);
            self.isGridReady = true;
          });
        },

        getRedemptionFlag: function () {
          var timer;
          var timeout = new Promise(function (resolve) {
            timer = $timeout(function () {
              resolve(false);
            }, REDEMPTION_FLAG_TIMEOUT_MS, false);
          });
          return Promise.race([LunchLitelyService.isEnabled(REDEMPTION_FLAG), timeout])
            .then(function (enabled) {
              return enabled === true;
            })
            .catch(function () {
              return false;
            })
            .then(function (enabled) {
              $timeout.cancel(timer);
              return enabled;
            });
        },

        initData: function (e, data) {
          var self = $scope.couponsList;
          var props = self.gridDefinition.getGridState();
          self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          self.search();
        },

        query: function () {
          var self = $scope.couponsList;
          self.gridState.setPropertyValue('search', self.searchQuery);
          self.gridState.setPropertyValue('redemptionStatus', self.redemptionStatus);
          $scope.$broadcast('DataGrid::Search', { name: self.gridName });
        },

        onRedemptionStatusChange: function () {
          var self = $scope.couponsList;
          self.gridDefinition.page = 1;
          self.gridDefinition.setPageNumber(1);
          self.gridState.setPropertyValue('page', 1);
          self.query();
        },

        search: function () {
          this.isLoaded = false;
          if (this.gridDefinition.userPreferencesLoaded) {
            this.getCouponsList();
          }
        },

        checkPermissions: function (permission) {
          var r = false;
          if (permission) {
            r = PermissionsService.check(permission);
          }
          return r;
        },

        getCouponsList: function () {
          var self = $scope.couponsList;
          var requestId = ++self.listRequestId;
          ApiService.coupons.list(self.gridState.getGridState()).then(
            function (response) {
              if (requestId === self.listRequestId) {
                self.success.getCouponsList(response);
              }
            },
            function (response) {
              if (requestId === self.listRequestId) {
                self.error.getCouponsList(response);
              }
            }
          );
        },

        getCouponCategories: function () {
          ApiService.coupons.categories
            .list(HelpersService.getPaginator())
            .then(this.success.getCouponCategories, this.error.getCouponCategories);
        },

        getAccounts: function () {
          ApiService.partners
            .list(HelpersService.getPaginator())
            .then(this.success.getAccounts, this.error.getAccounts);
        },

        createCoupon: function () {
          var self = $scope.couponsList;
          self.addModal = $uibModal.open({
            templateUrl: 'views/application/views/coupons/list/modals/createCoupon.tpl.html',
            size: 'lg',
            controller: 'CreateCouponModalController',
            resolve: {
              coupons: function () {
                return self.model;
              },
              categories: function () {
                return self.categories;
              },
              accounts: function () {
                return self.accounts;
              },
              isRedemptionEnabled: function () {
                return self.redemptionFlag;
              },
            },
          });

          self.addModal.result.then(
            function (couponObj) {
              ApiService.coupons.create(couponObj.coupon).then(
                function (response) {
                  var props;

                  self.success.create(response);
                  if (response.data.payload.id) {
                    props = {
                      couponId: response.data.payload.id,
                      effectiveStartDate: couponObj.effectiveDate.effectiveStartDate,
                      effectiveEndDate: couponObj.effectiveDate.effectiveEndDate,
                      notes: couponObj.effectiveDate.notes,
                    };
                    ApiService.coupons.effectiveDates.create(props);
                  }
                },
                function (response) {
                  self.error.create(response);
                }
              );
            },
            function () {
              //do nothing;
            }
          );
        },

        removeCoupon: function (item) {
          var self = $scope.couponsList;
          var coupon = item.entity;

          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/coupons/list/modals/removeCoupon.tpl.html',
            size: 'lg',
            controller: 'CouponRemoveModalController',
            resolve: {
              currentCoupon: function () {
                return coupon;
              },
            },
          });

          self.removeModal.result.then(
            function (coupon) {
              var self = $scope.couponsList;
              ApiService.coupons.remove(coupon.id).then(function (response) {
                self.search();
                self.success.remove(response);
              }, self.error.remove);
            },
            function () {
              //do nothing;
            }
          );
        },

        success: {
          getCouponsList: function (response) {
            var self = $scope.couponsList;
            self.model = response.data.payload.list;

            self.isLoaded = true;
            self.gridDefinition.isLoaded = true;

            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: self.gridDefinition.options.gridName,
                datasetLength: self.model.length,
                totalItems: response.data.payload.pagination.count,
              });
            });
          },

          getCouponCategories: function (response) {
            $scope.couponsList.categories = response.data.payload.list;
          },

          getAccounts: function (response) {
            $scope.couponsList.accounts = response.data.payload.list.map(function (account) {
              return account.company;
            });
          },

          create: function (response) {
            $scope.couponsList.search();
          },

          remove: function (response) {},
        },

        error: {
          getCouponsList: function (response) {
            var self = $scope.couponsList;
            self.isLoaded = true;
            self.gridDefinition.isLoaded = true;
          },

          getCouponCategories: function (response) {
            $scope.couponsList.categories = [];
          },

          getAccounts: function (response) {},

          create: function (response) {},

          remove: function (response) {},
        },

        onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
          var self = $scope.couponsList;
          self.gridState.updateGridState(newPage, pageSize);
          if (sortField) {
            self.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            self.gridState.updateGridState(null, null, null, sortDirection);
          }
          self.search();
        },

        onDblClick: function (item) {
          $state.go('application.coupons.create.detail', { couponId: item.entity.id });
        },

        onDataGridSortChange: function (grid, columns, page) {
          var self = $scope.couponsList;
          var data = columns[0];
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.search();
        },
      };

      $scope.couponsList.init();
    },
  ]);